import React from "react";

import { IGatsbyImageData } from "gatsby-plugin-image";

import ProductImage from "./productImage";

import { __t } from "../../utils/translate";

type CarouselThumbProps = {
    imageData: IGatsbyImageData;
    alt: string;
    onClick: () => void;
    idx: number;
    activePicture: number;
    isLast: boolean;
};

const CarouselThumb: React.FC<CarouselThumbProps> = ({ imageData, alt, onClick, idx, activePicture, isLast }) => {

    return (
        <div key={idx} onClick={onClick} className="" >
            <ProductImage
                className={`border cursor-pointer
                    ${idx === activePicture ? "border-dark-blu border-[2px] opacity-100" : "border-stroke-color border-[1px] opacity-80"}
                    hover:border-dark-blu transition-all duration-300 ease-in-out
                    md:h-[68px] md:w-[68px] lg:h-[86px] lg:w-[86px] xl:h-[103px] xl:w-[103px] mr-[10px]`}
                loading="lazy"
                imageData={imageData}
                alt={alt}
            />
        </div>
    );
};

export default CarouselThumb;